import React from "react";
import { Modal, Form, Input, Select, DatePicker, message } from "antd";
import moment from "moment";
import api from "../../services/api";

const { Option } = Select;
const { RangePicker } = DatePicker;

const TournamentFormModal = ({
  open,
  onClose,
  onSuccess,
  initialData = null,
}) => {
  const [form] = Form.useForm();
  const isEditing = !!initialData;

  const handleSubmit = async (values) => {
    try {
      const [start, end] = values.date_range;

      const payload = {
        name: values.name,
        sport: values.sport,
        category: values.category,
        status: values.status,
        level: values.level,
        start_date: start.format("YYYY-MM-DD"),
        end_date: end.format("YYYY-MM-DD"),
      };

      if (values.tournament_id) {
        await api.put(`/tournaments/${values.tournament_id}`, payload);
        message.success("Tournament updated");
      } else {
        await api.post("/tournaments", payload);
        message.success("Tournament created");
      }

      form.resetFields();
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error(err);
      message.error("Failed to save tournament");
    }
  };

  return (
    <Modal
      open={open}
      title={isEditing ? "Edit Tournament" : "Create Tournament"}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={() => form.submit()}
      okText={isEditing ? "Update" : "Create"}
      width="95%"
      style={{ top: 20 }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={
          initialData
            ? {
                ...initialData,
                date_range: [
                  moment(initialData.start_date),
                  moment(initialData.end_date),
                ],
              }
            : {}
        }
      >
        <Form.Item name="tournament_id" hidden>
          <Input />
        </Form.Item>

        <Form.Item
          name="name"
          label="Tournament Name"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="sport" label="Sport" rules={[{ required: true }]}>
          <Select>
            <Option value="cricket">Cricket</Option>
            <Option value="tennis_cricket">Tennis Cricket</Option>
          </Select>
        </Form.Item>

        <Form.Item name="category" label="Category" rules={[{ required: true }]}>
          <Select>
            <Option value="domestic">Domestic</Option>
            <Option value="international">International</Option>
          </Select>
        </Form.Item>

        <Form.Item name="status" label="Status" rules={[{ required: true }]}>
          <Select>
            <Option value="upcoming">Upcoming</Option>
            <Option value="live">Live</Option>
            <Option value="completed">Completed</Option>
          </Select>
        </Form.Item>

        <Form.Item name="level" label="Level" rules={[{ required: true }]}>
          <Select>
            <Option value="international">International</Option>
            <Option value="domestic">Domestic</Option>
            <Option value="local">Local</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="date_range"
          label="Tournament Dates"
          rules={[{ required: true }]}
        >
          <RangePicker style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TournamentFormModal;
